function addShipment(state, payload) {
  state.shipments[payload.id] = payload;
}

function deleteShipment(state, payload) {
  delete state.shipments[payload.shipmentId];
}

function deleteAllShipments(state) {
  state.shipments = {};
}

function setNewState(state, payload) {
  if (payload.target) {
    Vue.set(state.shipments[payload.shipmentId][payload.target], payload.name, payload.value);
    return;
  }
  Vue.set(state.shipments[payload.shipmentId], payload.name, payload.value);
}

function setShipmentData(state, payload) {
  if (payload.keys.length === 0) {
    state.shipments[payload.shipmentId][payload.target] = payload.value;
    return;
  }

  let target = state.shipments[payload.shipmentId][payload.target];
  const keysLength = payload.keys.length - 1;
  for (let i = 0; i < keysLength; i++) {
    target = target[payload.keys[i]];
  }
  target[payload.keys[keysLength]] = payload.value;
}

function incrementMultipleShipmentsCounter(state) {
  state.multipleShipmentsCounter += 1;
}

export default {
  addShipment,
  deleteShipment,
  deleteAllShipments,
  setNewState,
  setShipmentData,
  incrementMultipleShipmentsCounter,
}
